export const OrderNumber = ({ orderNumber }) => {
  return (
    <div className="order-number-container u-padding--x-small u-border surface-secondary">
      <span className="primary-text u-font-weight-600 surface-white u-border">{orderNumber}</span>
    </div>
  );
};
